import React, { useEffect, useState } from 'react';
import { useDebounce } from '../../hooks/use-debounce.hook';
import { TextInputComponent } from '../components/text-input.component';

let isOnChangeTriggered = false;
export function TextInputContainer ({ icon, type, name, label, value, onValueChange, placeholder, rows, multiline, isDisabled, isRequired }: any) {
  const [
    inputValue,
    setInputValue
  ] = useState(value);
  const debouncedInputValue = useDebounce(
    inputValue,
    500
  );

  useEffect(
    () => {
      if (debouncedInputValue && inputValue && debouncedInputValue === inputValue && isOnChangeTriggered) {
        isOnChangeTriggered = false;
        onValueChange({
          persist: () => {},
          target: {
            type: 'change',
            name,
            value: debouncedInputValue,
          },
        });
      }
    },
    [debouncedInputValue]
  )
  useEffect(
    () => {
      setInputValue(value)
    },
    [value]
  )
  return (<TextInputComponent
    icon={icon}
    isDisabled={isDisabled}
    isRequired={isRequired}
    label={label}
    multiline={multiline}
    name={name}
    onValueChange={(event: any) => {
      isOnChangeTriggered = true;
      setInputValue(event.target.value);
    } }
    placeholder={placeholder}
    rows={rows}
    type={type}
    value={inputValue} />)
}
